export enum EnumFileName {
  /**
   * 用户上传的头像缓存文件
   */
  USER_AVATAR = 'avatar'
}
